import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class CompanyService {
  constructor(private commonApiService: CommonApiService) {}

  saveKnowledgeBase(payload: FormData) {
    return this.commonApiService.post(APIURL.knowledgeBaseSave, payload);
  }

  getCompanyUserList() {
    return this.commonApiService.get(APIURL.companyUserList);
  }

  getTeamMembers() {
    return this.commonApiService.get(APIURL.teamMembers);
  }

  getTeamMemberInvites() {
    return this.commonApiService.get(APIURL.teamMemberInvites);
  }

  getCompanyDetail() {
    return this.commonApiService.get(APIURL.companyDetail);
  }

  getCompanysubscriptionoverview(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.subscriptionoverview, params);
  }

  getsubscriptioncredits(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.subscriptioncredits, params);
  }


  getsubscriptionusagehistory(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.subscriptionusagehistory, params);
  }

  getsubscriptioncreditpackages(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.subscriptioncreditpackages, params);
  }

  getsubscriptionautocreditpackages(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(
      APIURL.subscriptionautocreditpackages,
      params,
    );
  }

  getautoreloadoptions(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.getautoreloadoptions, params);
  }

  savesubscriptiontopup(payload: any) {
    return this.commonApiService.post(APIURL.subscriptiontopup, payload);
  }

  paymentcreatesubscription(payload: any) {
    return this.commonApiService.post(
      APIURL.paymentcreatesubscription,
      payload,
    );
  }
  
paymentcreatetopup(payload: any) {
    return this.commonApiService.post(
      APIURL.paymentcreatetopup,
      payload,
    );
  }
  

  saveautoreloadoptions(payload: any) {
    return this.commonApiService.post(APIURL.saveautoreloadoptions, payload);
  }

  getsavedautoreloadoptions(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.getsavedautoreloadoptions, params);
  }

  getplancomparison(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.plancomparison, params);
  }

  getplanlist(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.planlist, params);
  }

  getmyorganizations(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.myorganizations, params);
  }

  exitorganizations(payload: any) {
    return this.commonApiService.post(APIURL.exitorganizations, payload);
  }

  getusersdetail(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.usersdetail, params);
  }

  updateuserprofile(payload: any) {
    return this.commonApiService.post(APIURL.updateuserprofile, payload);
  }

  subscriptionensurefree(payload: any) {
    return this.commonApiService.post(APIURL.subscriptionensurefree, payload);
  }

  saveBillingInfo(payload: any) {
    return this.commonApiService.post(APIURL.billingInfoSave, payload);
  }

  getBillingInfo(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.billingInfoGet, params);
  }

  getorderdetailsGet(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.orderdetailsGet, params);
  }

  cancelSubscription(payload: any) {
    return this.commonApiService.post(APIURL.cancelSubscription, payload);
  }

  getsubscriptioninvoices(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.subscriptioninvoices, params);
  }

  getInvoiceDetails(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.invoiceDetails,params);
  }

   getnotificationsunreadcount(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.notificationsunreadcount, params);
  }

  getnotificationlist(payload) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.notificationlist, params);
  }

  postnotificationmark(payload) {
    return this.commonApiService.post(APIURL.notificationmark, payload);
  }

   companydetailsupdate(payload) {
    return this.commonApiService.post(APIURL.companydetailsupdate, payload);
  }

  adminInviteUser(payload) {
    return this.commonApiService.post(APIURL.invite_user, payload);
  }

  usersupdate(payload) {
    return this.commonApiService.post(APIURL.usersupdate, payload);
  }

   resendinvite(payload) {
    return this.commonApiService.post(APIURL.resend_invite, payload);
  }
}
